import { Dispatch } from 'react'
import { CountyActions } from '../../../../../store/County'
import { PublicWaterSystemsAggregatesActions, WaterSystemCoordinatesActions, WaterSystemsMetricsActions, ZoomLevel } from '../../../../../store/publicWaterSystem'
import { getStateCountiesPolygon } from '../../../../../utils/mapHelper'
import { AmericanStatesActions } from '../../../../../store/AmericanStates'

export const fetchAggregatedWaterSystems = async (
  dispatch: Dispatch<any>,
  zoomLevel: ZoomLevel,
  stateCode?: string,
): Promise<void> => {
  try {
    await dispatch(
      PublicWaterSystemsAggregatesActions.fetchAggregatedWaterSystemsAsync({
        zoomLevel,
        stateCode,
      }) as any,
    )
  } catch (error) {}
}

export const getStateFromZoom = async (
  dispatch,
  mapRef,
  code,
  prevSelectedCode,
  fetchAggregatedWaterSystems,
  stateName,
) => {
  dispatch(PublicWaterSystemsAggregatesActions.setZoomLevel(ZoomLevel.COUNTY))
  const countiesGeo = await getStateCountiesPolygon(code)
  if (countiesGeo) {
    mapRef.current.getSource('maine').setData(countiesGeo)
  }

  const options = {
    params: {
      state_abbr: code,
    },
  }

  dispatch(AmericanStatesActions.setSelectedState({state:stateName}))
  dispatch(WaterSystemsMetricsActions.fetchWaterSystemMetricsAsync({ options }) as any)

  prevSelectedCode.current = code
  await fetchAggregatedWaterSystems(dispatch, ZoomLevel.COUNTY, code)
}

export const getCoordinatesFromCounty = (
  dispatch,
  countyViolationsRef,
  countyName,
  prevSelectedCounty,
) => {
  const countyViolationsData = countyViolationsRef?.current
  const county = countyViolationsData?.find(
    (item) => item?.county_name?.trim()?.toLowerCase() === countyName?.trim()?.toLowerCase(),
  )

  if (county?.waterSystemIds) {
    prevSelectedCounty.current = countyName
    dispatch(CountyActions.setSelectedCounty(countyName))
    dispatch(
      WaterSystemCoordinatesActions.createWaterSystemCoordinatesAsync(county.waterSystemIds) as any,
    )
    const options = {
      params: {
        county_name: countyName,
      },
    }
    dispatch(WaterSystemsMetricsActions.fetchWaterSystemMetricsAsync({ options }) as any)
  }
}
